const discussions_es = require('./discussions.json')
export default discussions_es
